import React from 'react';
import { useMutation } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, Stack, Button, Portal, Typography, TextField, LinearProgress, Alert } from '@mui/material';
import { deleteEssentialDocumentAction } from '../../../services/request';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function ConfirmDelete ({ document, handleClose, setDocuments, setCount }) {
  const { loading, mutate, error } = useMutation(deleteEssentialDocumentAction);
  const [fileName, setFileName] = React.useState();

  const handleChange = e => setFileName(e.target.value);

  const handleDelete = async () => {
    const { error } = await mutate(document.id);

    if (!error) {
      setDocuments(prev => prev.filter(item => item.id !== document.id));
      setCount(prev => prev - 1);
      handleClose();
    }

  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardContent>
            <Typography variant="body1" textAlign="center">
              Czy na pewno chcesz usunąć plik <b>{document.file_name}</b>?
            </Typography>
            <Box height={20} />
            <TextField
              label="Przepisz nazwę pliku żeby usunąć"
              helperText="Tej czynności nie można cofnąć"
              fullWidth
              size="small"
              value={fileName}
              onChange={handleChange}
            />
            <Box height={20} />
            {error
              ? <>
                <Alert variant="outlined" severity="error" sx={{ width: '100%' }}>Wystąpił błąd</Alert>
                <Box height={20} />
              </> : null}
            <Stack flexDirection="row" justifyContent="space-around">
              {loading
                ? <LinearProgress sx={{ flex: 1 }} />
                : <>
                  <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Nie</Button>
                  <Button sx={{ flexGrow: 0.4 }} variant="contained" disabled={fileName !== document.file_name} onClick={handleDelete}>Tak</Button>
                </>}
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
